import {
  DisplayType,
  useCreateLiveDisplayMutation,
} from '../../../../generated/core-api/graphql-react-query';
import usePrevious from '../../../../Hooks/usePrevious';
import useHistory from '../../../Hooks/useHistory/useHistory';
import useIsWindowVisible from '../../../LiveContext/Hooks/useIsWindowVisible';
import useSessionStoreContext from '../../../LiveContext/NewSessionContext/Contexts/SessionStoreContextProvider/useSessionStoreContext';
import useGlobalStoreContext from '../Contexts/GlobalStoreContext/useGlobalStoreContext';
import useUpdateDisplay from './useUpdateDisplay';

export default function useDisplay() {
  const { latestDetection: [latestDetection], sessionId: [sessionId] } = useSessionStoreContext();
  const previousSessionId = usePrevious(sessionId);
  const { projectId: [projectId], displayId: [, setDisplayId] } = useGlobalStoreContext();
  const { navigate } = useHistory();
  const { isVisible } = useIsWindowVisible();

  const updateDisplay = useUpdateDisplay();

  const mutation = useCreateLiveDisplayMutation<Error>({
    onSuccess(data) {
      updateDisplay(data.createDisplay);
      setDisplayId(data.createDisplay.id);
    },
  });

  return (cardId: string, displayType: DisplayType, tabId?: string | null, contentMatches?: string[] | null) => {
    const queryParams = new URLSearchParams();
    if (tabId) {
      queryParams.append('tabId', tabId);
    }
    if (contentMatches && contentMatches.length > 0) {
      contentMatches.forEach((contentMatch) => {
        queryParams.append('contentMatch', contentMatch);
      });
    }
    const url = `/projects/${projectId}/cards/${cardId}?${queryParams.toString()}`;
    navigate(url);
    mutation.mutate({
      input: {
        cardId,
        tabId,
        displayType,
        isVisible,
        projectId,
        sessionId: sessionId ?? previousSessionId ?? undefined,
        detectionId: latestDetection?.id ?? undefined,
      },
    });
  };
}
